import { render, staticRenderFns } from "./CohortDegreesPage.vue?vue&type=template&id=221dd377&scoped=true"
import script from "./CohortDegreesPage.vue?vue&type=script&lang=js"
export * from "./CohortDegreesPage.vue?vue&type=script&lang=js"
import style0 from "./CohortDegreesPage.vue?vue&type=style&index=0&id=221dd377&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221dd377",
  null
  
)

export default component.exports